var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_94_1646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.14 0H91C100.65 0 109.43 3.96 115.8 10.32C122.18 16.69 126.14 25.48 126.14 35.14V87.75C126.14 97.39 122.18 106.17 115.82 112.54L115.8 112.56C109.42 118.93 100.64 122.88 91.01 122.88H39.14C29.48 122.88 20.69 118.92 14.32 112.56L14.08 112.29C7.86 105.95 4 97.27 4 87.74V35.14C4 25.47 7.95 16.69 14.32 10.32C20.69 3.95 29.47 0 39.14 0ZM95.51 31.02L95.58 31.13H117.18C116.31 25.45 113.6 20.35 109.7 16.44C104.9 11.64 98.28 8.66 91 8.66H82.13L95.51 31.02ZM85.52 31.13L72.07 8.66H42.57L56.18 31.13H85.52ZM46.11 31.13L32.95 9.39C28.14 10.55 23.83 13.04 20.44 16.44C16.54 20.34 13.84 25.45 12.96 31.13H46.11ZM117.48 39.79H12.66V87.75C12.66 94.92 15.55 101.45 20.22 106.23L20.44 106.44C25.24 111.24 31.87 114.23 39.14 114.23H91C98.28 114.23 104.9 111.25 109.69 106.46L109.71 106.44C114.5 101.65 117.48 95.03 117.48 87.75V39.79ZM54.95 54.95L81.78 72.4C82.21 72.68 82.6 73.04 82.91 73.48C84.13 75.25 83.68 77.68 81.91 78.9L55.19 94.67C54.52 95.22 53.66 95.55 52.71 95.55C50.55 95.55 48.8 93.8 48.8 91.64V58.15H48.82C48.82 57.38 49.05 56.6 49.52 55.92C50.76 54.15 53.19 53.72 54.95 54.95Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_94_1646",
    x: 0,
    y: 0,
    width: 130.141,
    height: 130.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_94_1646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_94_1646",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramPlay);
export default __webpack_public_path__ + "static/media/instagram-play.b28c7291a81df23b96607fb0e7b60541.svg";
export { ForwardRef as ReactComponent };